export default __webpack_public_path__ + "static/media/socialTwitter20.918825c2.svg";